import { useState } from "react";
import { faqs } from "@/mocks/entries";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full border-b border-background-200 bg-background-50 px-4 py-14 md:px-10 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-4">
          <span className="font-heading text-sm font-bold tracking-[0.2em] text-primary-600">FAQ</span>
          <h2 className="mt-3 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
            关于词条，你可能想问
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            如果这里没有解答你的疑问，可以在联系我们页面留下说明，我们会在两个工作日内回复。
          </p>
          <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-5">
            <div className="flex items-center gap-2 text-sm font-medium text-foreground-800">
              <i className="ri-information-line text-primary-600" />
              内容原则
            </div>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              我们只整理公开可查的信息，并明确区分事实、各方说法与仍存疑的部分。
            </p>
          </div>
        </div>

        <div className="lg:col-span-8">
          <dl className="divide-y divide-background-200 border-y border-background-200">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={item.q}>
                  <dt>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full items-start justify-between gap-4 py-5 text-left"
                    >
                      <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                        {item.q}
                      </h3>
                      <span
                        className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                      </span>
                    </button>
                  </dt>
                  {isOpen && (
                    <dd className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">{item.a}</dd>
                  )}
                </div>
              );
            })}
          </dl>
        </div>
      </div>
    </section>
  );
}